<!--
@Author: Calvin Green <calvin>
@Date:   2022-04-07T20:49:30+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T09:46:04+02:00
@Copyright: Diversitude 2022
-->

<template>
    <div>
        <b-row>
            <b-col cols="12">
                <h3>{{ form_data.company_name }}</h3>
            </b-col>
        </b-row>
        <b-tabs content-class="mt-3">
          <b-tab title="Supplier Info" active>
              <b-row>
                  <b-col cols="12">
                      <b-overlay :show="isLoading">
                          <b-form>
                              <b-row class="mb-3">
                                  <b-col cols="6">
                                      <label for="">Company Name</label>
                                      <b-form-input v-model="form_data.company_name"></b-form-input>
                                  </b-col>
                                  <b-col cols="6">
                                      <label for="">Company Email</label>
                                      <b-form-input v-model="form_data.company_email"></b-form-input>
                                  </b-col>
                              </b-row>

                              <b-row class="mb-3">
                                  <b-col cols="12">
                                      <label for="">Company Address</label>
                                      <b-form-textarea v-model="form_data.company_address"></b-form-textarea>
                                  </b-col>
                              </b-row>

                              <b-row class="mb-3">
                                  <b-col cols="6">
                                      <label class="col-form-label" for="">Contact Person</label>
                                      <b-form-input v-model="form_data.contact_person"></b-form-input>
                                  </b-col>
                                  <b-col cols="6">
                                      <label class="col-form-label" label-for="">Supplier Type</label>
                                      <b-form-select
                                          class="form-select"
                                          :options="supplierTypes"
                                          v-model="form_data.supplier_type_id"
                                      ></b-form-select>
                                  </b-col>
                              </b-row>

                              <b-row class="mb-3">
                                  <b-col cols="6">
                                      <label for="">Supplier Activity Description</label>
                                      <b-form-input v-model="form_data.activity_desc"></b-form-input>
                                  </b-col>
                              </b-row>
                          </b-form>
                      </b-overlay>
                  </b-col>
              </b-row>
              <b-button class="w-50" variant="primary" @click="saveSupplier">Save</b-button>
          </b-tab>
          <b-tab title="SLA's" @click="refreshWebix('suppliersSLATable')">
              <SupplierSLAs :slas="form_data.slas" :supplierId="editSupplierId" @updatedSupplier="reloadSupplier"></SupplierSLAs>
          </b-tab>
          <!-- <b-tab title="Linked Assets / Equipment">

          </b-tab> -->
        </b-tabs>
    </div>
</template>
<script>
import SupplierSLAs from './supplierSLAs.vue'
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'
import _ from 'lodash';
export default {
    data:() => ({
        isLoading: false,
        isEdit: false,
        editData: null,
        form_data:{
            id: -1,
            supplier_type_id: '',
            company_name: '',
            company_address: '',
            tel_no: '',
            fax_no: '',
            company_email: '',
            contact_person: '',
            activity_desc: '',
            slas: []
        },
        has_form_loaded: false,
    }),
    computed:{
        ...facilityAdminState,
        supplierTypes() {
            var supplierTypes = [];
            supplierTypes.push({value: "", text: "Please select a type"});
            var params;
            _.forEach(this.supplier_types, function(value) {
                params = {
                    value: value.id,
                    text: value.name
                };
                supplierTypes.push(params);
            });
            return supplierTypes;
        }
    },
    props: {
        editSupplierId: Number
    },
    components: {
        SupplierSLAs
    },
    methods: {
        ...facilityAdminMethods,
        updateFormData(newData){
            this.form_data = newData.form_data;
        },
        refreshWebix(id) {
            setTimeout(function () {
                /* eslint-disable no-undef */
                $$(id).refresh();
                $$(id).refreshColumns();
                /* eslint-enable no-undef */
            }, 250);
        },
        reloadSupplier() {
            this.loadClientSuppliers()
            .then(()=>{
                var findIndex = _.findIndex(this.client_suppliers, {id : this.editSupplierId});
                if (findIndex > -1) {
                    this.isEdit = true;
                    this.editData = this.client_suppliers[findIndex];
                    this.form_data.id = this.editData.id;
                    this.form_data.supplier_type_id = this.editData.supplier_type_id;
                    this.form_data.company_name = this.editData.company_name;
                    this.form_data.company_address = this.editData.company_address;
                    this.form_data.tel_no = this.editData.tel_no;
                    this.form_data.fax_no = this.editData.fax_no;
                    this.form_data.company_email = this.editData.company_email;
                    this.form_data.contact_person = this.editData.contact_person;
                    this.form_data.activity_desc = this.editData.activity_description;
                    this.form_data.slas = this.editData.slas;
                }
            })
        },
        saveSupplier(){
            this.form_data.id = this.editData.id;
            this.isLoading = true;
            this.saveClientSupplier(this.form_data)
            .then(()=>{
                this.reloadSupplier();
                this.isLoading = false;
            })
            .catch(()=>{
                this.isLoading = false;
            })
        },
    },
    mounted() {
        var findIndex = _.findIndex(this.client_suppliers, {id : this.editSupplierId});
        if (findIndex > -1) {
            this.isEdit = true;
            this.editData = this.client_suppliers[findIndex];
            this.form_data.id = this.editData.id;
            this.form_data.supplier_type_id = this.editData.supplier_type_id;
            this.form_data.company_name = this.editData.company_name;
            this.form_data.company_address = this.editData.company_address;
            this.form_data.tel_no = this.editData.tel_no;
            this.form_data.fax_no = this.editData.fax_no;
            this.form_data.company_email = this.editData.company_email;
            this.form_data.contact_person = this.editData.contact_person;
            this.form_data.activity_desc = this.editData.activity_description;
            this.form_data.slas = this.editData.slas;
        }
    },
    beforeDestroy(){
        //this.$eventHub.$off('editSupplier');
    }
}
</script>
